<!-- New Account Page Design -->
<ng-container *ngIf="(user$ | async) as user">

  <div fxLayout="row" fxLayout.lt-md="column" class="profile-wrapper">
    <div fxLayout="column" fxLayoutAlign="none center" class="side-menu" [ngClass.lt-md]="'side-menu side-menu--mobile'"
      fxFlexOrder.lt-md="2" fxFlexOrder="1">
      <div class="profile-picture">
        <img [src]="user?.photoURL" />
      </div>

      <div class="profile-details" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
        <div fxLayout="row" fxLayoutAlign="none center">
          <a routerLink="/profile">
            {{ user?.firstName }} {{ user?.lastName }}
          </a>
          <ng-container *ngIf="true">
            <svg class="feather verified">
              <use xlink:href="/assets/img/feather-sprite.svg#check-circle" />
            </svg>
          </ng-container>
        </div>
        <span class="sub" style="opacity: 0.8;">Joined {{ user?.creationTime | date: 'MMMM d, y'}}</span>
        <span class="sub">
          <app-rating-stars-label [rating]="0"></app-rating-stars-label>
          <span>(0 Reviews)</span>
        </span>
      </div>

      <div class="profile">
        <div class="rui-list" *ngIf="user && (user.emailVerified || user.mobileVerified)">
          <label>Verified</label>
          <p>
            <span *ngIf="user.mobileVerified">
              Phone Number
            </span>
            <span *ngIf="user.mobileVerified && user.emailVerified">
              ,
            </span>
            <span *ngIf="user.emailVerified">
              Email
            </span>
          </p>
          <hr />
        </div>
        <div class="rui-list" *ngIf="user && (!user.emailVerified || !user.mobileVerified)">
          <label>Not Verified</label>
          <p>
            <span *ngIf="!user.mobileVerified">
              Phone Number
            </span>
            <span *ngIf="!user.mobileVerified && !user.emailVerified">
              ,
            </span>
            <span *ngIf="!user.emailVerified">
              Email
            </span>
          </p>
          <hr />
        </div>
        <div class="rui-list">
          <label>About</label>
          <p>{{ user?.aboutMe != '' && user?.aboutMe ? user?.aboutMe : 'Add about you' }}</p>
          <hr />
        </div>
        <div class="rui-list">
          <label>Address</label>
          <p>{{ user?.address != '' && user?.address ? user?.address : 'Add your address' }}</p>
          <hr />
        </div>
        <div class="rui-list">
          <p>
            <svg class="feather responsive">
              <use xlink:href="/assets/img/feather-sprite.svg#zap" />
            </svg>
            Very Responsive
          </p>
          <hr />
        </div>
      </div>
    </div>

    <div class="profile-edit-container" fxFlexOrder.lt-md="1" fxFlexOrder="2">
      <router-outlet></router-outlet>
    </div>
  </div>
  <notifier-container></notifier-container>
</ng-container>